import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';

import { AssociationsSelector } from 'ui-library/components/AssociationsSelector/AssociationsSelector';
import { Form, Card, Typography } from 'antd';

import { FeesContext } from 'components/landlord_app/payments/LandlordFees';
import { getTranslatedString } from 'helpers/i18n';

const StyledSectionContainer = styled.div`
  margin-bottom: 32px;
`;

const requiredAtLeastOneAssociation = {
  validator: async (_, unit_ids) => {
    if (!unit_ids || unit_ids.length < 1) {
      return Promise.reject(
        new Error(getTranslatedString('landlordPortal.fees.attributes.associations.errorMessage'))
      );
    }
  },
};

const Associations = () => {
  const form = Form.useFormInstance();
  const feeData = useContext(FeesContext);
  const { feeAssociations } = feeData;

  const [dataSource, setDataSource] = useState([]);

  useEffect(() => {
    if (!!feeAssociations) {
      setDataSource(feeAssociations);
    }
  }, [feeAssociations]);

  const setSelected = (selectedRows) => {
    const unitIds = selectedRows.map((r) => r.split('__').slice(-1)).flat();
    form.setFieldsValue({ unit_ids: unitIds });
  };

  return (
    <Card>
      <StyledSectionContainer>
        <Typography.Title level={4}>
          {getTranslatedString('landlordPortal.fees.attributes.associations')}
        </Typography.Title>

        <Form.List
          name="unit_ids"
          rules={[requiredAtLeastOneAssociation]}
          shouldUpdate={(prevValues, currentValues) =>
            prevValues.unit_ids !== currentValues.unit_ids
          }
        >
          {(_fields, _operations, { errors }) => {
            return (
              <>
                <Form.ErrorList errors={errors} />

                <AssociationsSelector
                  cancelAction={() => {}}
                  loading={dataSource.length === 0}
                  dataSource={dataSource}
                  saveAction={() => {}}
                  onSelection={setSelected}
                  selectedRows={form.getFieldValue(['unit_ids']).map((id) => `unit__${id}`)}
                  showExactMatchCheckbox
                  asyncSave
                />
              </>
            );
          }}
        </Form.List>
      </StyledSectionContainer>
    </Card>
  );
};

export default Associations;
